<script>
  import { theme, toggleTheme } from '../services/themeService.js';
  import { t, currentLanguage, setLanguage } from '../services/i18n.js';
  import { navigate } from '../routes.js';

  const languages = [
    { code: 'pt', label: 'PT' },
    { code: 'en', label: 'EN' }
  ];
</script>

<header class="header">
  <div class="header-content">
    <a 
      href="/" 
      class="logo" 
      onclick={(e) => { e.preventDefault(); navigate('home'); }}
      aria-label="Baú da Gata - Página inicial"
    >
      <img src="/bau da gata extenso.png" alt="Baú da Gata" class="logo-image" />
    </a>

    <div class="header-actions">
      <!-- Language Selector -->
      <div class="language-selector">
        {#each languages as lang}
          <button
            class="lang-btn"
            class:active={$currentLanguage === lang.code}
            onclick={() => setLanguage(lang.code)}
            aria-label={`Mudar idioma para ${lang.label}`}
            aria-pressed={$currentLanguage === lang.code}
          >
            {lang.label}
          </button>
        {/each}
      </div>

      <!-- Theme Toggle -->
      <button
        class="theme-toggle"
        onclick={toggleTheme}
        aria-label={$theme === 'dark' ? $t('header.lightMode') : $t('header.darkMode')}
        title={$theme === 'dark' ? $t('header.lightMode') : $t('header.darkMode')}
      >
        {#if $theme === 'dark'}
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="5"/>
            <line x1="12" y1="1" x2="12" y2="3"/>
            <line x1="12" y1="21" x2="12" y2="23"/>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
            <line x1="1" y1="12" x2="3" y2="12"/>
            <line x1="21" y1="12" x2="23" y2="12"/>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
          </svg>
        {:else}
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
        {/if}
      </button>
    </div>
  </div>
</header>

<style>
  .header {
    background-color: var(--color-surface);
    border-bottom: 1px solid var(--color-border);
    position: sticky;
    top: 0;
    z-index: var(--z-header);
    box-shadow: var(--shadow-sm);
  }

  .header-content {
    max-width: var(--max-width);
    margin: 0 auto;
    padding: var(--spacing-md) var(--spacing-lg);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: opacity var(--transition-fast);
  }

  .logo:hover {
    opacity: 0.85;
  }

  .logo-image {
    height: 50px;
    width: auto;
    max-width: 250px;
    object-fit: contain;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
  }

  .language-selector {
    display: flex;
    gap: var(--spacing-xs);
    background-color: var(--color-background);
    border-radius: var(--border-radius);
    padding: 2px;
  }

  .lang-btn {
    padding: var(--spacing-xs) var(--spacing-sm);
    border: none;
    background: transparent;
    color: var(--color-text-secondary);
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    border-radius: calc(var(--border-radius) - 2px);
    transition: all var(--transition-fast);
  }

  .lang-btn:hover {
    color: var(--color-text);
  }

  .lang-btn.active {
    background-color: var(--color-primary);
    color: white;
  }

  .theme-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: none;
    background-color: var(--color-background);
    color: var(--color-text);
    border-radius: var(--border-radius);
    cursor: pointer;
    transition: all var(--transition-fast);
  }

  .theme-toggle:hover {
    background-color: var(--color-primary);
    color: white;
  }

  @media (max-width: 480px) {
    .header-content {
      padding: var(--spacing-sm) var(--spacing-md);
    }

    .logo-image {
      height: 40px;
      max-width: 150px;
    }
  }
</style>
